var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconGeneral = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8.38772 1.7426C8.16272 1.5526 7.83522 1.5526 7.61022 1.7426L1.01022 7.3426C0.757716 7.5576 0.727716 7.9351 0.940216 8.1876C1.15272 8.4401 1.53272 8.4701 1.78522 8.2576L2.40022 7.7376V12.4001C2.40022 13.5051 3.29522 14.4001 4.40022 14.4001H11.6002C12.7052 14.4001 13.6002 13.5051 13.6002 12.4001V7.7376L14.2127 8.2576C14.4652 8.4726 14.8452 8.4401 15.0577 8.1876C15.2702 7.9351 15.2402 7.5551 14.9877 7.3426L8.38772 1.7426ZM3.60022 12.4001V6.7201L8.00022 2.9876L12.4002 6.7201V12.4001C12.4002 12.8426 12.0427 13.2001 11.6002 13.2001H10.4002V9.4001C10.4002 8.8476 9.95272 8.4001 9.40022 8.4001H6.60022C6.04772 8.4001 5.60022 8.8476 5.60022 9.4001V13.2001H4.40022C3.95772 13.2001 3.60022 12.8426 3.60022 12.4001ZM6.80022 13.2001V9.6001H9.20022V13.2001H6.80022Z",
  fill: "currentColor"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconGeneral);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "4d836986545596bc80e38e885a74702f.svg";